import { type ReactNode } from 'react';

import styles from '../../BaseModal.module.scss';

interface Props {
    children: ReactNode;
    className?: string;
}

export const Footer = ({ className = '', children }: Props) => {
    if (!children) return null;

    return <footer className={`${styles.footer} ${className}`.trim()}>{children}</footer>;
};
